import React from 'react';
import PromoteBadge from '~/components/promote-badge/promote-badge';
import GetTheBookDropdown from './dropdown-menu';
import cn from 'classnames';
import './book-tile.scss';
export default function BookTile({ book }) {
    var _a;
    const { coverUrl, title, slug } = book;
    const comingSoon = book.bookState === 'coming_soon';
    const snippets = (_a = book.promoteSnippet) === null || _a === void 0 ? void 0 : _a.filter((s) => s.value.image);
    const promoteSnippet = snippets === null || snippets === void 0 ? void 0 : snippets.find((s) => s.value.image);
    const classes = cn({
        'book-tile': true,
        'coming-soon': comingSoon,
        promote: Boolean(promoteSnippet)
    });
    return (React.createElement("div", { className: classes },
        React.createElement("a", { href: `/details/${slug}`, "aria-label": `${title} book` },
            React.createElement("img", { src: coverUrl, role: 'presentation', width: '240', height: '240' }),
            (promoteSnippet === null || promoteSnippet === void 0 ? void 0 : promoteSnippet.value.image) && (React.createElement(PromoteBadge, { name: promoteSnippet.value.name, image: promoteSnippet.value.image })),
            React.createElement("div", { className: 'text-block' }, title)),
        comingSoon ? (React.createElement("div", { className: 'navmenu' },
            React.createElement("button", { type: 'button', disabled: true }, "Coming soon"))) : (React.createElement(GetTheBookDropdown, { bookInfo: book }))));
}
